var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"validate-home-page"},[_c('detail',{ref:"postDetail"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }